import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { UiWindowService } from '@myapp/modules/fwcore/services';

import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { TriStateCheckBoxComponent, ClickFilterComponent } from '@myapp/features/widgets/components';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { FormFieldModule, TextAreaModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { UtcToLocalPipe } from '../../../../../modules/fwcore/pipes/utc-to-local.pipe';
import { RoleTemplate, RoleType } from '../../../models';

@Component({
  selector: 'app-role-template-editor',
  templateUrl: './role-template-editor.component.html',
  styleUrls: ['./role-template-editor.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgIf, DialogModule, FormsModule, ReactiveFormsModule, FormFieldModule, LabelModule, TextBoxModule, TriStateCheckBoxComponent
    , ClickFilterComponent, NgClass, DropDownListModule, TextAreaModule, ButtonModule, AsyncPipe, UtcToLocalPipe]
})

export class RoleTemplateEditorComponent implements OnChanges {

  /*-------------------------- Input / Outputs --------------------------------*/

  @Input() editDataItem: RoleTemplate | null | undefined;

  @Input() isReadOnly?: boolean = false;
  @Input() isNew?: boolean;

  @Output() cancel: EventEmitter<undefined> = new EventEmitter();
  @Output() save: EventEmitter<RoleTemplate> = new EventEmitter();

  /*-------------------------- public properties / methods --------------------*/

  public active: boolean = false;

  public editForm: FormGroup = new FormGroup({
    id: new FormControl()
    , roleType: new FormControl()
    , applicationId: new FormControl()
    , moduleId: new FormControl()
    , name: new FormControl("", Validators.required)
    , isActive: new FormControl()
    , intDescription: new FormControl()
    , lastModifiedBy: new FormControl()
    , lastModifiedOn: new FormControl()
    , roleTypeName: new FormControl()
    , lastModifiedByName: new FormControl()
  });

  protected roleTypeOptions = Object.keys(RoleType).map(key => ({
    name: RoleType[key as keyof typeof RoleType],
    value: key
  }));

  /*-------------------------- Constructor  --------------------------*/

  constructor(public afUiWin: UiWindowService) {
  }

  /*--------------------------- event handlers  --------------------------*/

  ngOnChanges(changes: SimpleChanges) {

    if (changes.editDataItem) {

      this.editForm.reset(this.editDataItem);

      // toggle the Dialog visibility
      this.active = !!(this.editDataItem);
    }
  }

  /*--------------------------- event handlers  --------------------------*/

  protected onSave(e: PointerEvent): void {
    e.preventDefault();

    this.save.emit(this.editForm.value);
    this.active = false;
  }

  protected onCancel(e: PointerEvent): void {
    e.preventDefault();

    this.closeForm();
  }

  /*--------------------------- internal functions  --------------------------*/

  protected closeForm(): void {
    this.active = false;
    this.cancel.emit();
  }
}
